import { FloatsAndTiesTableMarkdownItem } from './floats-and-ties-table-markdown-item.js';
import { JsonBodyRemarkPlugin } from './markdown-plugins-utils.js';

import type { RemarkMarkdownDirectiveDefinition } from './markdown-plugins-utils.js';

/** Directive name used in markdown container blocks: `:::floats-and-ties-table` */
export const FLOATS_AND_TIES_TABLE_DIRECTIVE = 'floats-and-ties-table';

/**
 * Remark plugin definition for the `floats-and-ties-table` container directive.
 *
 * Usage in markdown:
 * ```
 * :::floats-and-ties-table
 * [JSON array]
 * :::
 * ```
 *
 * The directive body is parsed as JSON and passed to {@link FloatsAndTiesTableMarkdownItem}
 * via the `jsonData` prop.
 */
export const floatsAndTiesTableDirectiveDefinition: RemarkMarkdownDirectiveDefinition = {
	allowedAttributes: ['jsonData'],
	directive: JsonBodyRemarkPlugin(FLOATS_AND_TIES_TABLE_DIRECTIVE),
	item: FloatsAndTiesTableMarkdownItem,
};
